import React from 'react';
import FloatingChatbot from './components/chatbot/FloatingChatbot.jsx';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Your existing website content */}
      {/* <header className="App-header">
        <h1>Your Website</h1>
        <p>This is your existing content. The chatbot floats on every page!</p>
      </header> */}
      
      {/* Floating Chatbot - appears on every page */}
      <FloatingChatbot />
    </div>
  );
}

export default App;
